"use client";
import Cookies from "js-cookie";
import { FC, useEffect, useState } from "react";
import styles from "./BigCommerceAdminBar.module.scss";
import { Environment } from "@/lib/bigcommerce/config/types";

interface Props {
	environment: Environment;
	storeInfo: any;
}

const BigCommerceAdminBar: FC<Props> = ({ environment, storeInfo }) => {
	const [isShown, setIsShown] = useState(environment !== "production");

	useEffect(() => {
		const hideAdminBar = Cookies.get("hide_admin_bar") === "true";

		if (hideAdminBar) {
			return;
		}

		const initShow = storeInfo ? environment !== "production" : false;

		setIsShown(initShow);
	}, [storeInfo]);

	const handleHide = () => {
		setIsShown(false);
		Cookies.set("hide_admin_bar", "true", { expires: 1 });
	};

	if (!isShown) {
		return null;
	}

	return (
		<div className={styles.container}>
			<div className={styles.logo}>
				<a href={`${storeInfo.control_panel_base_url}/manage/dashboard`}>
					<img src={storeInfo.favicon_url} alt={storeInfo.name} />
				</a>
			</div>

			<div className={styles.info}>
				<p>{`${storeInfo.name} (${storeInfo.plan_level})`}</p>
			</div>

			<div
				className={styles.close}
				onClick={handleHide}
				onKeyDown={(e) => e.key === "Enter" && handleHide()}
			>
				<img
					src='https://microapps.bigcommerce.com/storefront-admin-bar/static/admin-close-f1e71b4b.svg'
					alt='Close admin bar'
				/>
			</div>
		</div>
	);
};

export default BigCommerceAdminBar;
